export default __webpack_public_path__ + "static/media/Dr. Nighat IMG_4760.cd57b226.jpg";